import "./Profile.css";
import NavBar from "../NavBar";
import React from "react";
import ProfileMessage from "./Components/messagess";
import Profile from "./Components/profile-component";
import Notes from "./Components/notes";
import Calendar from "./Components/calender";

function ProfileDash() {
  return (
    <>
      <NavBar />
      <div className="profile-contain">
        <Profile />
        <div style={{display:'flex'}}>
        <div style={{width:'58%'}}>
          <ProfileMessage />
          <Notes />
          </div>
          <Calendar />
        </div>
      </div>
    </>
  );
}
export default ProfileDash;
